module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vbl-radio', {
    attrs: {
      "native-value": "0"
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_vm._v("香蕉")]), _c('vbl-radio', {
    attrs: {
      "native-value": "1"
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_vm._v("苹果")]), _c('vbl-radio', {
    attrs: {
      "native-value": "2",
      "disabled": ""
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_vm._v("禁用")]), _c('br'), _c('br'), _vm._v("\n    " + _vm._s(_vm.val) + "\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b6c3be5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblRadio/example/vblRadioExample.vue
// module id = 284
// module chunks = 0